import { useFallbackStorageValue } from "shared/hooks";

export const useIsFirstTimeVisitDashboardWidget = () => {
  const { set: setIsFirstTime, value: isFirstTime } = useFallbackStorageValue<boolean>(
    "isFirstTimeVisitSCMPNotificationWidgetVersionTwo",
    {
      defaultValue: true,
    },
  );

  return { isFirstTime, setIsFirstTime };
};
